import BenchlingConfig from 'BenchlingConfig';
import {OrganizationPermissionRole, TeamPermissionRole} from 'orgs/OrganizationConstants';
import {UserColumnTypes, UserRowInfo} from 'parties/users/UsersForm';
import * as net from 'util/Net';
import * as TaskRunner from 'util/TaskRunner';

// TODO (BNCH-85909) Refactor these methods into UserDAO.ts to match their backend counterparts.
export function createUsers(
  usersSpreadsheetURL: string | null | undefined,
  userInfosWithEmailErrorFlags: Array<UserRowInfo> | null,
  organizationInfos: Array<{organizationId: string; role: OrganizationPermissionRole}>,
  teamInfos: Array<{teamId: string; role: TeamPermissionRole}>,
  shouldSendEmails: boolean
): JQueryPromise<{}> {
  let userInfos = null;
  if (userInfosWithEmailErrorFlags) {
    userInfos = userInfosWithEmailErrorFlags.map((oldInfo) => ({
      [UserColumnTypes.EMAIL]: oldInfo.EMAIL,
      [UserColumnTypes.NAME]: oldInfo.NAME,
      [UserColumnTypes.HANDLE]: oldInfo.HANDLE,
    }));
  }
  return TaskRunner.postJSON({
    url: `/1/api/tenants/${BenchlingConfig.TENANT_NAME}:create-users`,
    data: {
      usersSpreadsheetURL,
      userInfos,
      organizationInfos,
      teamInfos,
      shouldSendEmails,
    },
  });
}

export function update(
  tenantName: string,
  data: Partial<{displayName: string; avatarUrl: string}>
): Promise<{displayName: string; avatarUrl: string}> {
  return net.patchJSONPromise({
    url: `/1/api/tenants/${tenantName}`,
    data,
  });
}

export function updateConfigs(data: {configsToSet: {[configKey: string]: string}}): Promise<{}> {
  return net.postJSONPromise({
    url: `/1/api/tenant:update-configs`,
    data,
  });
}

export function updateIPAllowlists(
  data: Partial<{
    webIPAllowlist: Array<string>;
    warehouseIpAllowlist: Array<string>;
    useWebIpAllowlistForWH: boolean;
  }>
): Promise<{}> {
  return TaskRunner.patchJSONPromise({
    url: `/1/api/tenant:update-ip-allowlists`,
    data,
  });
}

export function updatePermissionControls(
  data: Partial<{
    folder_permissions_enabled: boolean;
  }>
): Promise<{}> {
  return net.patchJSONPromise({
    url: `/1/api/tenant:permission-controls`,
    data,
  });
}
